<template>
    <div>
        <form-with-data :policy-type="policyType" :is-edit="isEdit" :id="id" ref="formWithData" :isIntegral="isIntegral"></form-with-data>
        <div :class="$style['policy-form-button-div']">
            <el-button type="primary" @click="submit" :loading="loading">保存</el-button>
            <el-button type="primary" plain @click="cancel">取消</el-button>
        </div>
    </div>
</template>
<script>
import formWithData from './withData.vue'
export default {
  components: {
    formWithData
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    policyType: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    isIntegral: Boolean
  },
  data () {
    return {
    }
  },
  methods: {
    submit () {
      this.$refs.formWithData.submit()
    },
    cancel () {
      history.go(-1)
    }
  }
}
</script>
<style module lang="less">
.policy-form-button-div{

}
</style>
